import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M12 3.923c-4.461 0-8.077 3.616-8.077 8.077S7.539 20.077 12 20.077s8.077-3.616 8.077-8.077S16.461 3.923 12 3.923zm0 14.808a6.73 6.73 0 1 1 0-13.462 6.73 6.73 0 0 1 0 13.462z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M18.119 12a6.12 6.12 0 1 1-12.24-.001A6.12 6.12 0 0 1 18.12 12z"
  })]
}), 'Camerabutton');